import Vue from 'vue';
import Vuex from 'vuex';

import { auth } from './auth.module';
import { maintenance } from './maintenance.module';
import { security } from './security.module';
import { administration } from './administration.module';
import { tools } from './tools.module';
import { transactions } from './transaction.module';
import { dealing } from './dealing.module';
import { Uploads } from './upload_module'

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    maintenance,
    security,
    administration,
    tools,
    transactions,
    dealing,
    Uploads
  }
});